import { toCamelCase } from '../../shared/to-camel-case/to-camel-case';
import { AccountApiInterface, AccountNapDataApiInterface } from './account.api.interface';

export class AccountNapData {
  companyName: string;
  id: string;
  address: string;

  static fromApiModel(model: AccountNapDataApiInterface): AccountNapData {
    const accountNapData = new AccountNapData();
    for (const key in model) {
      if (Object.prototype.hasOwnProperty.call(model, key)) {
        accountNapData[toCamelCase(key)] = model[key];
      }
    }
    return accountNapData;
  }
}

export class Account {
  id: string;
  partnerId: string;

  companyName: string;
  address: string;
  state: string;
  country: string;
  website: string;
  zip: string;
  created: Date;
  updated: Date;
  contactEmail: string;

  static fromApiModel(model: AccountApiInterface): Account {
    const account = new Account();
    for (const key in model) {
      if (Object.prototype.hasOwnProperty.call(model, key)) {
        account[toCamelCase(key)] = model[key];
      }
    }
    return account;
  }
}
